import React from 'react';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedPreviewAssetsStepWithI18n } from './delayed-preview-assets-step';

export const PreviewAssetsStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ASSETS,
  render: () => <DelayedPreviewAssetsStepWithI18n />,
};
